export const PDF_URLS: Record<string, string> = {
  byTransportation: "v2/seller/details_by_growers/pdf",
  byCustomer: "v2/seller/products_by_order/pdf",
  byGrower: "v2/seller/details_by_growers_customers/pdf",
  byGeneralClient: "v2/seller/products_by_customers/pdf",
  printCustomerReport: "v2/seller/customers_report/pdf",
}